import { UNLABELED } from '@/features/datasets/components/DataSelection/RawRecordsStatus/constants';

const VALID_TAB_KEYS = new Set([
    'train-set',
    'benchmark',
    'archived-datasets',
    'archived-benchmarks',
]);

/**
 * Resolve the Data Editor deep-link URL params (`tab`, `labelFilter`) into the
 * page state they should seed.
 *
 * `?labelFilter=unlabeled` pre-selects the Labels column filter on the
 * "Unlabeled" bucket. It targets the train-set tab by default; benchmark
 * label-generation entry points (e.g. the FloatingProgressBar "Review them
 * manually" link on a benchmark upload) pass `tab=benchmark` to filter the
 * benchmark table instead.
 *
 * @param {URLSearchParams} searchParams
 * @returns {{
 *   hasDeepLink: boolean,
 *   activeTab: string,
 *   unlabeledTarget: 'train-set' | 'benchmark' | null,
 *   unlabeledFilters: Object | null,
 * }}
 */
export function resolveDataSelectionDeepLink(searchParams) {
    const tabParam = searchParams?.get?.('tab') || null;
    const wantsUnlabeled = searchParams?.get?.('labelFilter') === 'unlabeled';
    const requestedTab = VALID_TAB_KEYS.has(tabParam) ? tabParam : null;

    if (wantsUnlabeled) {
        const activeTab = requestedTab === 'benchmark' ? 'benchmark' : 'train-set';
        return {
            hasDeepLink: true,
            activeTab,
            unlabeledTarget: activeTab,
            unlabeledFilters: { is_in_dataset: true, labels: [UNLABELED] },
        };
    }
    if (requestedTab) {
        return {
            hasDeepLink: true,
            activeTab: requestedTab,
            unlabeledTarget: null,
            unlabeledFilters: null,
        };
    }
    return {
        hasDeepLink: false,
        activeTab: 'train-set',
        unlabeledTarget: null,
        unlabeledFilters: null,
    };
}
